// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_he","advertCardFooter__row":"c-a_hf","advertCardFooter__name":"c-a_hg","advertCardFooter__price":"c-a_hh","advertCardFooter__age":"c-a_hi"};